// extracted by mini-css-extract-plugin
module.exports = {"root":"error-boundary_root__2Z3SM","heading":"error-boundary_heading__1MeqA"};